module.exports = __webpack_public_path__ + "img/view-order-img.88625881.png";